import React, { useState } from 'react';
import { Maximize2, MessageSquare } from 'lucide-react';
import Thread from '../Thread/Thread';
import ModalShell from '../Modal/ModalShell';

export default function ProjectDiscussion({
  projectId,
  placeholder,
  height,
  className = '',
  stickyTop = 16,
  pendingMilestone = null,
  onPendingMilestoneChange,
  onMilestoneClick,
}) {
  const [expanded, setExpanded] = useState(false);
  const openMilestone = (milestoneId) => {
    if (expanded) {
      setExpanded(false);
      setTimeout(() => onMilestoneClick?.(milestoneId), 80);
      return;
    }
    onMilestoneClick?.(milestoneId);
  };

  return (
    <>
      <div className={`project-discussion-panel ${className}`.trim()} style={{ position: 'sticky', top: stickyTop }}>
        <div className="project-discussion-heading">
          <div className="project-discussion-title">
            <span><MessageSquare size={16} /></span>
            <div><h3>Project discussion</h3><p>Client and project team conversation</p></div>
          </div>
          <button
            type="button"
            className="project-chat-expand"
            onClick={() => setExpanded(true)}
            aria-label="Expand project discussion"
            title="Expand chat"
          >
            <Maximize2 size={14} /> <span>Expand conversation</span>
          </button>
        </div>
        {!expanded && (
          <Thread
            threadType="project"
            threadId={projectId}
            height={height}
            placeholder={placeholder}
            pendingMilestone={pendingMilestone}
            onPendingMilestoneChange={onPendingMilestoneChange}
            onMilestoneClick={openMilestone}
          />
        )}
      </div>

      {expanded && (
        <ModalShell
          title="Project discussion"
          subtitle="Client and project team conversation"
          eyebrow="Expanded conversation"
          icon={MessageSquare}
          size="chat"
          className="project-chat-modal"
          bodyClassName="project-chat-modal-body"
          onClose={() => setExpanded(false)}
        >
          <Thread
            threadType="project"
            threadId={projectId}
            height="100%"
            placeholder={placeholder}
            pendingMilestone={pendingMilestone}
            onPendingMilestoneChange={onPendingMilestoneChange}
            onMilestoneClick={openMilestone}
          />
        </ModalShell>
      )}
    </>
  );
}
